import { Component, ElementRef, NgZone, Renderer2 } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CantinaService } from '../../_servizi/cantina.service';
import { MessageServiceService } from '../../_servizi/message-service.service';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';
import { Recensione } from 'src/app/_classi/Recensione';
import { trigger, transition, style, animate } from '@angular/animations';
import * as moment from 'moment';
@Component({
  selector: 'app-recensioni',
  templateUrl: './recensioni.component.html',
  styleUrls: ['./recensioni.component.css'],
  animations: [
    trigger('slideAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-100%)' }),
        animate('500ms', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('500ms', style({ opacity: 0, transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class RecensioniComponent {

  get fromMobile() {
    return this.appoggioService.getFromMobile();
  }

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  abilitatoVenditaVino = false;
  nonabilitatoMsg = '';

  codiceForm: any;
  linguaCorrente: string;
  layout: number;
  cart: any;

  vini: any[] = [];
  viniFiltered: any[] = [];
  pacchetti: any[] = [];
  pacchettiFiltered: any[] = [];

  loading = false;

  isFiltrati = true;

  recensioni: Recensione[] = [];
  currentSlide = 0;
  currentSlideNext = 1;

  paginatedItems: Recensione[] = [];
  itemsPerPage: number = 5;
  currentPage: number = 0;
  stars = [1, 2, 3, 4, 5];

  constructor(
    private messageService: MessageServiceService,
    private host: ElementRef,
    private zone: NgZone,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private adapter: DateAdapter<any>,
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService,
    private renderer: Renderer2
  ) { }


  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.codiceForm = params.get('cantina');
      this.translate.use('it');
      this.controllaCantina(this.codiceForm);
    });
  }

  ngOnDestroy(): void {
    this.observer.unobserve(this.host.nativeElement);
  }

  controllaCantina(codiceForm): void {
    this.loading = true;
    this.cantinaService.getStato(codiceForm)
      .subscribe(result => {
        this.checkAbilitato = true;
        if (result && result.length > 0) {
          const cantina = result[0];
          this.abilitato = true
          this.appoggioService.setCodiceForm(codiceForm);

          this.appoggioService.setColoriIframe(cantina);

          this.cantinaService.getRecensioni(codiceForm)
            .subscribe(result => {
              this.recensioni = result.map(recensione => new Recensione(recensione));
              this.updatePaginatedItems();

              this.observer = new ResizeObserver(entries => {
                this.zone.run(() => {
                  this.messageService.sendHeighMessageRecensioni(entries[0].contentRect.height);
                });
              });
              this.observer.observe(this.host.nativeElement);
            });

        } else {
          this.abilitato = false;
          this.nonabilitatoMsg = 'nonAbilitato';
        }
        setTimeout(() => {
          this.loading = false;
        }, 2000)
      });
  }

  updatePaginatedItems() {
    const start = this.currentPage * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedItems = this.recensioni.slice(start, end);
  }

  onPageChange(event: any) {
    this.currentPage = event.page;
    this.updatePaginatedItems();
  }

  calcolaDifferenza(dataStringa: string): string {
    moment.locale(this.translate.currentLang);
    const dataFornita = moment(dataStringa, 'DD-MM-YYYY');
    if (!dataFornita.isValid()) {
      return 'Data non valida';
    }
    return dataFornita.fromNow();
  }

  i = 0;

  getSlide() {
    return this.recensioni[this.i];
  }

  getSlideNext() {
    const i = this.i + 1 < this.recensioni.length ? this.i + 1 : 0;
    return this.recensioni[i];
  }

  getPrev() {
    this.i = this.i === 0 ? this.recensioni.length - 1 : this.i - 1;

  }

  getNext() {
    this.i = this.i === this.recensioni.length - 1 ? 0 : this.i + 1;
  }

  triggerAnimation() {
    const elements = document.querySelectorAll('.recensione');
    elements.forEach((element) => {
      this.renderer.removeClass(element, 'animate');
      void element['offsetWidth'];
      this.renderer.addClass(element, 'animate');
    });
  }
}
